import React from 'react';
import './ErrorLayer.css';
import ActionButton from '../ActionButton';

function ErrorLayer(props) {
    return (
            <div className="ErrorLayer">
                <div className="ErrorLayer-container">
                    <h2 className="ErrorLayer-msg-title">{props.errorTitle}</h2>
                    <p className="ErrorLayer-msg">{props.errorMsg}</p>
                    <p className="ErrorLayer-msg">{props.tryAgainMsg}</p>
                    <ActionButton buttonMsg={props.buttonMsg} onClickButton={props.buttonHandler}/>
                </div>
            </div>
    );
}

export default ErrorLayer;


// WEBPACK FOOTER //
// ./src/components/ErrorLayer/ErrorLayer.js